import type { RestProduct } from "@KassaroAB/shared/types/product";

export type ProductSortColumn =
  | "name"
  | "articleNumber"
  | "barcodeCode"
  | "group"
  | "type"
  | "vat"
  | "unitPrice"
  | "stockCount"
  | "updatedAt";

export interface ProductGroupNameRow {
  id: string;
  name: string;
}

export type ProductPresenceFilter = "has" | "none";

export const PRODUCT_FILTER_NONE = "__none__";

export interface ProductQuery {
  search: string;
  groupId: string | null;
  type: string | null;
  vat: number | null;
  stockFilter: ProductPresenceFilter | null;
  bookkeepingAccountFilter: string | null;
  variantsFilter: ProductPresenceFilter | null;
  supplierFilter: string | null;
  unitFilter: string | null;
  updatedSince: string | null;
  priceMin: number | null;
  priceMax: number | null;
  productIds: string[] | null;
  sortColumn: ProductSortColumn;
  sortDirection: "asc" | "desc";
  offset: number;
  limit: number;
}

export interface ProductQueryResult {
  rows: RestProduct[];
  total: number;
}

export interface ProductStoreMeta {
  count: number;
  maxUpdatedAt: string | null;
}

export type ProductStoreRequest =
  | { id: number; type: "init"; storeId: string }
  | { id: number; type: "upsertMany"; products: RestProduct[] }
  | { id: number; type: "deleteMany"; ids: string[] }
  | { id: number; type: "query"; query: ProductQuery }
  | { id: number; type: "meta" }
  | { id: number; type: "clear" }
  | { id: number; type: "setGroups"; groups: ProductGroupNameRow[] };

export type ProductStoreResponse =
  | { id: number; type: "init"; meta: ProductStoreMeta }
  | { id: number; type: "upsertMany" }
  | { id: number; type: "deleteMany" }
  | { id: number; type: "query"; result: ProductQueryResult }
  | { id: number; type: "meta"; meta: ProductStoreMeta }
  | { id: number; type: "clear" }
  | { id: number; type: "setGroups" }
  | { id: number; type: "error"; message: string };
